import PropTypes from "prop-types";

export default PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
  })
);
